import React from 'react';
import PropTypes from 'prop-types';
import { Link, browserHistory } from 'react-router';
import { List } from 'immutable';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';

export default class OrderOverviewReport extends React.Component {
  static propTypes = {
    accountReportData: PropTypes.instanceOf(List).isRequired,
  };

  getReportRow = r => (
    <tr key={r.orderId}>
      <td>{r.customerId}</td>
      <td>{r.customer}</td>
      <td>{r.accountsMatched}</td>
      <td>{r.accountsProspected}</td>
      <td>{r.contactsMatched}</td>
      <td>{r.contactsProspected}</td>
      <td>{r.leadsMatched}</td>
      <td>{r.leadsProspected}</td>
      <td>
        <Link className="btn btn-sm btn-primary-outline" to={`/order-reports/${r.orderId}`}>
          Detail
        </Link>
      </td>
    </tr>
  );

  render() {
    const { accountReportData } = this.props;
    return (
      <div className="modal-wrap">
        <div className="container-fluid container-home">
          <div className="header">
            <div className="header-body">
              <div className="row">
                <div className="col-sm-12">
                  <h1 className="header-title">Order Overview</h1>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <div className="card-border">
                <div className="card-header">
                  <div className="card-header-title">Data Report Overview</div>
                </div>
                <div className="card-block">
                  <div style={{ width: '100%', height: 400 }}>
                    <ResponsiveContainer>
                      <BarChart
                        maxBarSize={60}
                        data={accountReportData.toJS()}
                        margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                        onClick={e =>
                          browserHistory.push(
                            `/order-reports/${e.activePayload[0].payload.orderId}`
                          )
                        }
                      >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="customer" />
                        <YAxis />
                        <Tooltip />
                        <Legend />
                        <Bar
                          dataKey="accountsMatched"
                          name="Accounts Matched"
                          stackId="a"
                          fill="#8884d8"
                        />
                        <Bar
                          dataKey="accountsProspected"
                          name="Accounts Prospected"
                          stackId="a"
                          fill="#82ca9d"
                        />
                        <Bar
                          dataKey="contactsMatched"
                          name="Contacts Matched"
                          stackId="a"
                          fill="#2c7be5"
                        />
                        <Bar
                          dataKey="contactsProspected"
                          name="Contacts Prospected"
                          stackId="a"
                          fill="#39afd1"
                        />
                        <Bar
                          dataKey="leadsMatched"
                          name="Leads Matched"
                          stackId="a"
                          fill="#6e84a3"
                        />
                        <Bar
                          dataKey="leadsProspected"
                          name="Leads Prospected"
                          stackId="a"
                          fill="#283e59"
                        />
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <table className="table">
                <thead>
                  <tr>
                    <th scope="col">Customer Id</th>
                    <th scope="col">Customer</th>
                    <th scope="col">Accounts Matched</th>
                    <th scope="col">Accounts Prospected</th>
                    <th scope="col">Contacts Matched</th>
                    <th scope="col">Contacts Prospected</th>
                    <th scope="col">Leads Matched</th>
                    <th scope="col">Leads Prospected</th>
                    <th scope="col">Detail</th>
                  </tr>
                </thead>
                <tbody>{accountReportData.map(this.getReportRow)}</tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
